export default {
	en: {
		name: 'English',
		messages: require('./en.json')
	},
	de: {
		name: 'Deutsch',
		messages: require('./de.json')
	}
};
